import React from "react";

export const Aerospace = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6443_68)">
        <mask
          id="path-1-outside-1_6443_68"
          maskUnits="userSpaceOnUse"
          x="-1.55635"
          y="-1.41421"
          width="31.1127"
          height="31.1127"
          fill="black"
        >
          <rect
            fill="white"
            x="-1.55635"
            y="-1.41421"
            width="31.1127"
            height="31.1127"
          />
          <path d="M21.0711 7.07107C20.3755 6.37545 19.4058 6.45235 18.6643 6.69895C17.9091 6.96427 17.2218 7.39316 16.6517 7.95495L13.3892 11.2174L10.7376 10.3335L10.9064 10.1647C11.0236 10.0474 11.0895 9.88848 11.0895 9.72272C11.0895 9.55696 11.0236 9.39799 10.9064 9.28078L10.0225 8.39689C9.90531 8.27968 9.74634 8.21383 9.58058 8.21383C9.41482 8.21383 9.25585 8.27968 9.13864 8.39689L8.08594 9.4496L6.53472 8.93253C6.20427 8.82215 5.84961 8.80603 5.51051 8.88596C5.17141 8.9659 4.86129 9.13873 4.61493 9.38507L3.3934 10.6066C3.32928 10.6708 3.2799 10.7482 3.24869 10.8333C3.21748 10.9185 3.20519 11.0095 3.21268 11.0999C3.22016 11.1903 3.24724 11.278 3.29203 11.3569C3.33683 11.4358 3.39826 11.504 3.47206 11.5568L5.15409 12.758L4.60255 13.8628C4.54424 13.9801 4.52423 14.1127 4.54535 14.2419C4.56646 14.3711 4.62763 14.4905 4.72023 14.5831C4.81282 14.6757 4.93216 14.7368 5.06139 14.758C5.19062 14.7791 5.32322 14.7591 5.44047 14.7007L6.87148 13.9857L9.15102 15.6129L7.49108 17.9358L5.16117 17.9358C5.03739 17.9356 4.91635 17.9722 4.8134 18.0409C4.71045 18.1096 4.63022 18.2074 4.58289 18.3217C4.53555 18.4361 4.52324 18.5619 4.54751 18.6833C4.57178 18.8047 4.63154 18.9161 4.71922 19.0035L9.13864 23.4229C9.22601 23.5106 9.33744 23.5704 9.45881 23.5946C9.58019 23.6189 9.70603 23.6066 9.8204 23.5592C9.93477 23.5119 10.0325 23.4317 10.1012 23.3287C10.1699 23.2258 10.2065 23.1047 10.2064 22.981L10.2064 20.6511L12.5292 18.9911L14.1564 21.2707L13.4414 22.7017C13.3831 22.8189 13.3631 22.9515 13.3842 23.0807C13.4053 23.21 13.4665 23.3293 13.5591 23.4219C13.6517 23.5145 13.771 23.5757 13.9002 23.5968C14.0295 23.6179 14.1621 23.5979 14.2793 23.5396L15.3842 22.988L16.5845 24.6692C16.6372 24.7432 16.7053 24.8048 16.7843 24.8498C16.8632 24.8948 16.951 24.922 17.0416 24.9296C17.1321 24.9371 17.2232 24.9249 17.3085 24.8937C17.3938 24.8624 17.4713 24.813 17.5355 24.7487L18.7571 23.5272C19.0034 23.2809 19.1762 22.9707 19.2562 22.6316C19.3361 22.2925 19.32 21.9379 19.2096 21.6074L18.6925 20.0562L19.7452 19.0035C19.8625 18.8863 19.9283 18.7273 19.9283 18.5616C19.9283 18.3958 19.8625 18.2368 19.7452 18.1196L18.8614 17.2357C18.7441 17.1185 18.5852 17.0527 18.4194 17.0527C18.2537 17.0527 18.0947 17.1185 17.9775 17.2357L17.8087 17.4045L16.9248 14.7529L20.1872 11.4905C20.6892 10.9884 21.1869 10.2433 21.4432 9.47788C21.6907 8.73542 21.7667 7.76668 21.0711 7.07107ZM17.5355 8.83883C17.9174 8.457 18.4981 8.07074 19.0585 7.88512C19.6418 7.69067 19.9989 7.76668 20.1872 7.95495C20.3755 8.14322 20.4523 8.49942 20.257 9.08367C20.0714 9.64229 19.6843 10.2256 19.3033 10.6066L15.7678 14.1421C15.6858 14.2241 15.6282 14.3274 15.6015 14.4402C15.5748 14.5531 15.58 14.6711 15.6166 14.7812L18.0243 22.0043C18.0609 22.1143 18.0661 22.2324 18.0394 22.3453C18.0127 22.4581 17.9552 22.5613 17.8732 22.6433L17.1731 23.3434L13.1824 17.7563C13.0862 17.6217 12.9405 17.5308 12.7772 17.5034C12.614 17.4761 12.4466 17.5146 12.3118 17.6105L9.21819 19.8202C9.1369 19.8781 9.07064 19.9546 9.02497 20.0433C8.9793 20.132 8.95554 20.2304 8.95568 20.3302L8.95568 21.4722L6.66995 19.1865L7.81282 19.1873C7.91238 19.1874 8.01053 19.1637 8.09909 19.1182C8.18764 19.0727 8.26405 19.0067 8.32193 18.9257L10.5316 15.8321C10.5794 15.7653 10.6135 15.6897 10.632 15.6097C10.6506 15.5296 10.6531 15.4467 10.6396 15.3657C10.626 15.2847 10.5966 15.2071 10.5531 15.1374C10.5096 15.0678 10.4527 15.0074 10.3858 14.9597L4.79877 10.969L5.49881 10.269C5.58082 10.187 5.68402 10.1294 5.79688 10.1027C5.90974 10.076 6.0278 10.0812 6.13786 10.1178L13.361 12.5255C13.471 12.5621 13.5891 12.5673 13.7019 12.5406C13.8148 12.5139 13.918 12.4564 14 12.3744L17.5355 8.83883Z" />
        </mask>
        <path
          d="M21.0711 7.07107C20.3755 6.37545 19.4058 6.45235 18.6643 6.69895C17.9091 6.96427 17.2218 7.39316 16.6517 7.95495L13.3892 11.2174L10.7376 10.3335L10.9064 10.1647C11.0236 10.0474 11.0895 9.88848 11.0895 9.72272C11.0895 9.55696 11.0236 9.39799 10.9064 9.28078L10.0225 8.39689C9.90531 8.27968 9.74634 8.21383 9.58058 8.21383C9.41482 8.21383 9.25585 8.27968 9.13864 8.39689L8.08594 9.4496L6.53472 8.93253C6.20427 8.82215 5.84961 8.80603 5.51051 8.88596C5.17141 8.9659 4.86129 9.13873 4.61493 9.38507L3.3934 10.6066C3.32928 10.6708 3.2799 10.7482 3.24869 10.8333C3.21748 10.9185 3.20519 11.0095 3.21268 11.0999C3.22016 11.1903 3.24724 11.278 3.29203 11.3569C3.33683 11.4358 3.39826 11.504 3.47206 11.5568L5.15409 12.758L4.60255 13.8628C4.54424 13.9801 4.52423 14.1127 4.54535 14.2419C4.56646 14.3711 4.62763 14.4905 4.72023 14.5831C4.81282 14.6757 4.93216 14.7368 5.06139 14.758C5.19062 14.7791 5.32322 14.7591 5.44047 14.7007L6.87148 13.9857L9.15102 15.6129L7.49108 17.9358L5.16117 17.9358C5.03739 17.9356 4.91635 17.9722 4.8134 18.0409C4.71045 18.1096 4.63022 18.2074 4.58289 18.3217C4.53555 18.4361 4.52324 18.5619 4.54751 18.6833C4.57178 18.8047 4.63154 18.9161 4.71922 19.0035L9.13864 23.4229C9.22601 23.5106 9.33744 23.5704 9.45881 23.5946C9.58019 23.6189 9.70603 23.6066 9.8204 23.5592C9.93477 23.5119 10.0325 23.4317 10.1012 23.3287C10.1699 23.2258 10.2065 23.1047 10.2064 22.981L10.2064 20.6511L12.5292 18.9911L14.1564 21.2707L13.4414 22.7017C13.3831 22.8189 13.3631 22.9515 13.3842 23.0807C13.4053 23.21 13.4665 23.3293 13.5591 23.4219C13.6517 23.5145 13.771 23.5757 13.9002 23.5968C14.0295 23.6179 14.1621 23.5979 14.2793 23.5396L15.3842 22.988L16.5845 24.6692C16.6372 24.7432 16.7053 24.8048 16.7843 24.8498C16.8632 24.8948 16.951 24.922 17.0416 24.9296C17.1321 24.9371 17.2232 24.9249 17.3085 24.8937C17.3938 24.8624 17.4713 24.813 17.5355 24.7487L18.7571 23.5272C19.0034 23.2809 19.1762 22.9707 19.2562 22.6316C19.3361 22.2925 19.32 21.9379 19.2096 21.6074L18.6925 20.0562L19.7452 19.0035C19.8625 18.8863 19.9283 18.7273 19.9283 18.5616C19.9283 18.3958 19.8625 18.2368 19.7452 18.1196L18.8614 17.2357C18.7441 17.1185 18.5852 17.0527 18.4194 17.0527C18.2537 17.0527 18.0947 17.1185 17.9775 17.2357L17.8087 17.4045L16.9248 14.7529L20.1872 11.4905C20.6892 10.9884 21.1869 10.2433 21.4432 9.47788C21.6907 8.73542 21.7667 7.76668 21.0711 7.07107ZM17.5355 8.83883C17.9174 8.457 18.4981 8.07074 19.0585 7.88512C19.6418 7.69067 19.9989 7.76668 20.1872 7.95495C20.3755 8.14322 20.4523 8.49942 20.257 9.08367C20.0714 9.64229 19.6843 10.2256 19.3033 10.6066L15.7678 14.1421C15.6858 14.2241 15.6282 14.3274 15.6015 14.4402C15.5748 14.5531 15.58 14.6711 15.6166 14.7812L18.0243 22.0043C18.0609 22.1143 18.0661 22.2324 18.0394 22.3453C18.0127 22.4581 17.9552 22.5613 17.8732 22.6433L17.1731 23.3434L13.1824 17.7563C13.0862 17.6217 12.9405 17.5308 12.7772 17.5034C12.614 17.4761 12.4466 17.5146 12.3118 17.6105L9.21819 19.8202C9.1369 19.8781 9.07064 19.9546 9.02497 20.0433C8.9793 20.132 8.95554 20.2304 8.95568 20.3302L8.95568 21.4722L6.66995 19.1865L7.81282 19.1873C7.91238 19.1874 8.01053 19.1637 8.09909 19.1182C8.18764 19.0727 8.26405 19.0067 8.32193 18.9257L10.5316 15.8321C10.5794 15.7653 10.6135 15.6897 10.632 15.6097C10.6506 15.5296 10.6531 15.4467 10.6396 15.3657C10.626 15.2847 10.5966 15.2071 10.5531 15.1374C10.5096 15.0678 10.4527 15.0074 10.3858 14.9597L4.79877 10.969L5.49881 10.269C5.58082 10.187 5.68402 10.1294 5.79688 10.1027C5.90974 10.076 6.0278 10.0812 6.13786 10.1178L13.361 12.5255C13.471 12.5621 13.5891 12.5673 13.7019 12.5406C13.8148 12.5139 13.918 12.4564 14 12.3744L17.5355 8.83883Z"
          fill="#595959"
          className="group-hover:fill-purple-500"
        />
        <path
          d="M21.0711 7.07107C20.3755 6.37545 19.4058 6.45235 18.6643 6.69895C17.9091 6.96427 17.2218 7.39316 16.6517 7.95495L13.3892 11.2174L10.7376 10.3335L10.9064 10.1647C11.0236 10.0474 11.0895 9.88848 11.0895 9.72272C11.0895 9.55696 11.0236 9.39799 10.9064 9.28078L10.0225 8.39689C9.90531 8.27968 9.74634 8.21383 9.58058 8.21383C9.41482 8.21383 9.25585 8.27968 9.13864 8.39689L8.08594 9.4496L6.53472 8.93253C6.20427 8.82215 5.84961 8.80603 5.51051 8.88596C5.17141 8.9659 4.86129 9.13873 4.61493 9.38507L3.3934 10.6066C3.32928 10.6708 3.2799 10.7482 3.24869 10.8333C3.21748 10.9185 3.20519 11.0095 3.21268 11.0999C3.22016 11.1903 3.24724 11.278 3.29203 11.3569C3.33683 11.4358 3.39826 11.504 3.47206 11.5568L5.15409 12.758L4.60255 13.8628C4.54424 13.9801 4.52423 14.1127 4.54535 14.2419C4.56646 14.3711 4.62763 14.4905 4.72023 14.5831C4.81282 14.6757 4.93216 14.7368 5.06139 14.758C5.19062 14.7791 5.32322 14.7591 5.44047 14.7007L6.87148 13.9857L9.15102 15.6129L7.49108 17.9358L5.16117 17.9358C5.03739 17.9356 4.91635 17.9722 4.8134 18.0409C4.71045 18.1096 4.63022 18.2074 4.58289 18.3217C4.53555 18.4361 4.52324 18.5619 4.54751 18.6833C4.57178 18.8047 4.63154 18.9161 4.71922 19.0035L9.13864 23.4229C9.22601 23.5106 9.33744 23.5704 9.45881 23.5946C9.58019 23.6189 9.70603 23.6066 9.8204 23.5592C9.93477 23.5119 10.0325 23.4317 10.1012 23.3287C10.1699 23.2258 10.2065 23.1047 10.2064 22.981L10.2064 20.6511L12.5292 18.9911L14.1564 21.2707L13.4414 22.7017C13.3831 22.8189 13.3631 22.9515 13.3842 23.0807C13.4053 23.21 13.4665 23.3293 13.5591 23.4219C13.6517 23.5145 13.771 23.5757 13.9002 23.5968C14.0295 23.6179 14.1621 23.5979 14.2793 23.5396L15.3842 22.988L16.5845 24.6692C16.6372 24.7432 16.7053 24.8048 16.7843 24.8498C16.8632 24.8948 16.951 24.922 17.0416 24.9296C17.1321 24.9371 17.2232 24.9249 17.3085 24.8937C17.3938 24.8624 17.4713 24.813 17.5355 24.7487L18.7571 23.5272C19.0034 23.2809 19.1762 22.9707 19.2562 22.6316C19.3361 22.2925 19.32 21.9379 19.2096 21.6074L18.6925 20.0562L19.7452 19.0035C19.8625 18.8863 19.9283 18.7273 19.9283 18.5616C19.9283 18.3958 19.8625 18.2368 19.7452 18.1196L18.8614 17.2357C18.7441 17.1185 18.5852 17.0527 18.4194 17.0527C18.2537 17.0527 18.0947 17.1185 17.9775 17.2357L17.8087 17.4045L16.9248 14.7529L20.1872 11.4905C20.6892 10.9884 21.1869 10.2433 21.4432 9.47788C21.6907 8.73542 21.7667 7.76668 21.0711 7.07107ZM17.5355 8.83883C17.9174 8.457 18.4981 8.07074 19.0585 7.88512C19.6418 7.69067 19.9989 7.76668 20.1872 7.95495C20.3755 8.14322 20.4523 8.49942 20.257 9.08367C20.0714 9.64229 19.6843 10.2256 19.3033 10.6066L15.7678 14.1421C15.6858 14.2241 15.6282 14.3274 15.6015 14.4402C15.5748 14.5531 15.58 14.6711 15.6166 14.7812L18.0243 22.0043C18.0609 22.1143 18.0661 22.2324 18.0394 22.3453C18.0127 22.4581 17.9552 22.5613 17.8732 22.6433L17.1731 23.3434L13.1824 17.7563C13.0862 17.6217 12.9405 17.5308 12.7772 17.5034C12.614 17.4761 12.4466 17.5146 12.3118 17.6105L9.21819 19.8202C9.1369 19.8781 9.07064 19.9546 9.02497 20.0433C8.9793 20.132 8.95554 20.2304 8.95568 20.3302L8.95568 21.4722L6.66995 19.1865L7.81282 19.1873C7.91238 19.1874 8.01053 19.1637 8.09909 19.1182C8.18764 19.0727 8.26405 19.0067 8.32193 18.9257L10.5316 15.8321C10.5794 15.7653 10.6135 15.6897 10.632 15.6097C10.6506 15.5296 10.6531 15.4467 10.6396 15.3657C10.626 15.2847 10.5966 15.2071 10.5531 15.1374C10.5096 15.0678 10.4527 15.0074 10.3858 14.9597L4.79877 10.969L5.49881 10.269C5.58082 10.187 5.68402 10.1294 5.79688 10.1027C5.90974 10.076 6.0278 10.0812 6.13786 10.1178L13.361 12.5255C13.471 12.5621 13.5891 12.5673 13.7019 12.5406C13.8148 12.5139 13.918 12.4564 14 12.3744L17.5355 8.83883Z"
          stroke="#595959"
          stroke-width="0.6"
          mask="url(#path-1-outside-1_6443_68)"
          className="group-hover:stroke-purple-500"
        />
      </g>
      <defs>
        <clipPath id="clip0_6443_68">
          <rect width="29" height="29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ComputerVision = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      role="presentation"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6443_74)">
        <g clip-path="url(#clip1_6443_74)">
          <path
            d="M5.83337 23.1667H16.6667V12.3333H5.83337V23.1667ZM13.3334 19.8333H24.1667V9.00001H13.3334V19.8333ZM9.16671 15.6667H20V4.83334H9.16671V15.6667Z"
            stroke="#595959"
            stroke-width="2"
            className="group-hover:stroke-purple-500"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6443_74">
          <rect width="29" height="29" fill="white" />
        </clipPath>
        <clipPath id="clip1_6443_74">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(5 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Healthcare = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      role="presentation"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6443_142)">
        <g clip-path="url(#clip1_6443_142)">
          <path
            d="M12.5 15H10V12H12.5V9.5H15.5V12H18V15H15.5V17.5H12.5V15ZM14 4L6 7V13.09C6 18.14 9.41 22.85 14 24C18.59 22.85 22 18.14 22 13.09V7L14 4ZM20 13.09C20 17.09 17.45 20.79 14 21.92C10.55 20.79 8 17.1 8 13.09V8.39L14 6.14L20 8.39V13.09Z"
            fill="#595959"
            className="group-hover:fill-purple-500"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6443_142">
          <rect width="29" height="29" fill="white" />
        </clipPath>
        <clipPath id="clip1_6443_142">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Energy = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      role="presentation"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6443_193)">
        <path
          d="M16.1162 2.64327L14.2828 12.2759L20.9246 12.2982L11.8839 25.3567L13.7173 14.7593L7.07592 14.7361L16.1162 2.64327ZM16.1174 1.0183C16.0735 1.0183 16.0297 1.0199 15.9866 1.02312C15.6998 1.04631 15.5097 1.14218 15.2842 1.29371C15.1573 1.37835 15.0428 1.48036 14.9442 1.59677C14.9146 1.63171 14.8866 1.66805 14.8605 1.70565L5.7552 13.7562C5.39567 14.249 5.34286 14.8995 5.61911 15.443C5.89495 15.9866 6.45273 16.3311 7.06414 16.3355L11.7547 16.3697L10.28 25.0581C10.1399 25.8048 10.538 26.5491 11.2388 26.8489C11.4424 26.9364 11.6618 26.9815 11.8835 26.9813C12.3941 26.9813 12.8138 26.7425 13.1286 26.311L22.2453 13.2525C22.6048 12.7597 22.6573 12.1085 22.3814 11.5657C22.1055 11.0222 21.5478 10.6776 20.9364 10.6732L16.2458 10.6651L17.7046 3.02553C17.7356 2.90046 17.7511 2.77209 17.751 2.64325C17.751 1.76412 17.051 1.0475 16.1751 1.01906C16.1556 1.01825 16.1365 1.01825 16.1174 1.01825L16.1174 1.0183Z"
          fill="#595959"
          className="group-hover:fill-purple-500"
        />
      </g>
      <defs>
        <clipPath id="clip0_6443_193">
          <rect width="29" height="29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Agriculture = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <path
        d="M4.72794 9.19441H9.27339C9.27339 7.91385 8.45521 6.86612 7.45521 6.86612H4.72794C4.22794 6.86612 3.81885 7.38998 3.81885 8.03026C3.81885 8.67054 4.22794 9.19441 4.72794 9.19441Z"
        fill="#595959"
        className="group-hover:fill-purple-500"
      />
      <path
        d="M21.0909 15.085V8.03027C21.0909 6.74971 20.2727 5.70198 19.2727 5.70198H13.5545L12.5909 4.46799L13.8727 2.82654L13.2273 2L10.0182 6.10943L10.6636 6.93597L11.9455 5.29453L12.9091 6.52852V9.19441C12.9091 10.475 12.0909 11.5227 11.0909 11.5227H9.23636C9.03636 11.3364 8.82727 11.1735 8.60909 11.0221L8.24545 12.0582L7.82727 11.8137L8.19091 10.766C7.69091 10.5099 7.12727 10.3586 6.54545 10.3586C6.06364 10.3586 5.6 10.4866 5.16364 10.6612L5.47273 11.7206L5.04545 11.9302L4.72727 10.8475C3.76775 11.385 2.98597 12.3367 2.51818 13.5367L3.32727 14.0023L3.13636 14.5378L2.31818 14.0722C2.11818 14.7125 2 15.4342 2 16.1793C2 16.7963 2.1 17.39 2.23636 17.9488L3.06364 17.553L3.22727 18.1001L2.38182 18.5076C2.80159 19.7363 3.54477 20.7374 4.48182 21.3364L4.84545 20.3004L5.26364 20.5448L4.9 21.5925C5.4 21.8487 5.96364 22 6.54545 22C7.02727 22 7.49091 21.8719 7.92727 21.6973L7.61818 20.638L8.04545 20.4284L8.36364 21.5111C9.32315 20.9735 10.1049 20.0218 10.5727 18.8219L9.76364 18.3562L9.95455 17.8207L10.7727 18.2864C10.8636 17.9837 10.9364 17.6577 10.9909 17.3318H15.6818C15.6636 17.5297 15.6364 17.7276 15.6364 17.9255C15.6364 20.1723 17.0636 22 18.8182 22C20.5727 22 22 20.1723 22 17.9255C22 16.8196 21.6545 15.8184 21.0909 15.085ZM6.54545 19.6717C5.03636 19.6717 3.81818 18.1118 3.81818 16.1793C3.81818 14.2468 5.03636 12.6868 6.54545 12.6868C8.05455 12.6868 9.27273 14.2468 9.27273 16.1793C9.27273 18.1118 8.05455 19.6717 6.54545 19.6717ZM10.9727 15.0151C10.9364 14.8056 10.9 14.6077 10.8545 14.4098L10.0273 14.8056L9.86364 14.2584L10.7091 13.851H11.0909C13.1 13.851 14.7273 11.7672 14.7273 9.19441V8.03027H19.2727V13.9092C19.1273 13.8859 18.9727 13.851 18.8182 13.851C17.9545 13.851 17.1727 14.2934 16.6 15.0151H10.9727ZM18.8182 19.6717C18.0636 19.6717 17.4545 18.8917 17.4545 17.9255C17.4545 16.9593 18.0636 16.1793 18.8182 16.1793C19.5727 16.1793 20.1818 16.9593 20.1818 17.9255C20.1818 18.8917 19.5727 19.6717 18.8182 19.6717Z"
        fill="#595959"
        className="group-hover:fill-purple-500"
      />
    </svg>
  );
};

export const Retail = () => {
  return (
    <svg
      width="29"
      height="29"
      role="presentation"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6443_180)">
        <path
          d="M25.8163 13.6492L25.0647 5.71211C25.0266 5.30078 24.6991 4.97578 24.2878 4.93516L16.3507 4.18359H16.3405C16.2593 4.18359 16.1958 4.20898 16.1475 4.25723L4.25711 16.1477C4.23358 16.1711 4.2149 16.199 4.20216 16.2298C4.18942 16.2605 4.18286 16.2934 4.18286 16.3267C4.18286 16.3599 4.18942 16.3928 4.20216 16.4236C4.2149 16.4543 4.23358 16.4822 4.25711 16.5057L13.4942 25.7428C13.5425 25.791 13.6059 25.8164 13.6745 25.8164C13.7431 25.8164 13.8065 25.791 13.8548 25.7428L25.7452 13.8523C25.796 13.799 25.8214 13.7254 25.8163 13.6492ZM13.672 23.1936L6.80633 16.3279L16.955 6.1793L23.2264 6.77344L23.8206 13.0449L13.672 23.1936ZM19.2655 8.5C18.0341 8.5 17.0311 9.50293 17.0311 10.7344C17.0311 11.9658 18.0341 12.9688 19.2655 12.9688C20.497 12.9688 21.4999 11.9658 21.4999 10.7344C21.4999 9.50293 20.497 8.5 19.2655 8.5ZM19.2655 11.5469C18.8161 11.5469 18.453 11.1838 18.453 10.7344C18.453 10.285 18.8161 9.92188 19.2655 9.92188C19.7149 9.92188 20.078 10.285 20.078 10.7344C20.078 11.1838 19.7149 11.5469 19.2655 11.5469Z"
          fill="#595959"
          className="group-hover:fill-purple-500"
        />
      </g>
      <defs>
        <clipPath id="clip0_6443_180">
          <rect width="29" height="29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Media = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      role="presentation"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6490_128)">
        <path
          d="M21.0438 2.83905H5.8532C4.68381 2.83905 3.73584 3.78702 3.73584 4.95641V20.147C3.73584 21.3164 4.68381 22.2643 5.8532 22.2643H21.0438C22.2132 22.2643 23.1611 21.3164 23.1611 20.147V4.95641C23.1611 3.78702 22.2132 2.83905 21.0438 2.83905Z"
          stroke="#595959"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="group-hover:stroke-purple-500"
        />
        <path
          d="M8.59204 2.83905V22.2643"
          stroke="#595959"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="group-hover:stroke-purple-500"
        />
        <path
          d="M18.3047 2.83905V22.2643"
          stroke="#595959"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="group-hover:stroke-purple-500"
        />
        <path
          d="M3.73584 12.5517H23.1611"
          stroke="#595959"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="group-hover:stroke-purple-500"
        />
        <path
          d="M3.73584 7.69537H8.59216"
          stroke="#595959"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="group-hover:stroke-purple-500"
        />
        <path
          d="M3.73584 17.408H8.59216"
          stroke="#595959"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="group-hover:stroke-purple-500"
        />
        <path
          d="M18.3047 17.408H23.161"
          stroke="#595959"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="group-hover:stroke-purple-500"
        />
        <path
          d="M18.3047 7.69537H23.161"
          stroke="#595959"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="group-hover:stroke-purple-500"
        />
      </g>
      <defs>
        <clipPath id="clip0_6490_128">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Manufacturing = () => {
  return (
    <svg
      width="29"
      height="29"
      role="presentation"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6490_121)">
        <path
          d="M14.1875 18.875C14.1875 19.1982 14.0591 19.5082 13.8305 19.7368C13.602 19.9653 13.292 20.0938 12.9688 20.0938H10.125C9.80177 20.0938 9.49177 19.9653 9.26321 19.7368C9.03465 19.5082 8.90625 19.1982 8.90625 18.875C8.90625 18.5518 9.03465 18.2418 9.26321 18.0132C9.49177 17.7847 9.80177 17.6562 10.125 17.6562H12.9688C13.292 17.6562 13.602 17.7847 13.8305 18.0132C14.0591 18.2418 14.1875 18.5518 14.1875 18.875ZM19.875 17.6562H17.0312C16.708 17.6562 16.398 17.7847 16.1695 18.0132C15.9409 18.2418 15.8125 18.5518 15.8125 18.875C15.8125 19.1982 15.9409 19.5082 16.1695 19.7368C16.398 19.9653 16.708 20.0938 17.0312 20.0938H19.875C20.1982 20.0938 20.5082 19.9653 20.7368 19.7368C20.9653 19.5082 21.0938 19.1982 21.0938 18.875C21.0938 18.5518 20.9653 18.2418 20.7368 18.0132C20.5082 17.7847 20.1982 17.6562 19.875 17.6562ZM27.5938 22.9375C27.5938 23.2607 27.4653 23.5707 27.2368 23.7993C27.0082 24.0278 26.6982 24.1562 26.375 24.1562H3.625C3.30177 24.1562 2.99177 24.0278 2.76321 23.7993C2.53465 23.5707 2.40625 23.2607 2.40625 22.9375C2.40625 22.6143 2.53465 22.3043 2.76321 22.0757C2.99177 21.8472 3.30177 21.7188 3.625 21.7188H4.84375V9.9375C4.84375 9.71116 4.90678 9.4893 5.02577 9.29676C5.14476 9.10423 5.31502 8.94864 5.51746 8.84742C5.7199 8.7462 5.94653 8.70335 6.17195 8.72367C6.39737 8.744 6.61268 8.8267 6.79375 8.9625L11.3438 12.375V9.9375C11.3438 9.71116 11.4068 9.4893 11.5258 9.29676C11.6448 9.10423 11.815 8.94864 12.0175 8.84742C12.2199 8.7462 12.4465 8.70335 12.672 8.72367C12.8974 8.744 13.1127 8.8267 13.2937 8.9625L16.6788 11.5016L17.7564 3.96258C17.8276 3.47943 18.0696 3.03781 18.4386 2.71786C18.8075 2.3979 19.279 2.22082 19.7673 2.21875H21.6077C22.096 2.22082 22.5675 2.3979 22.9364 2.71786C23.3054 3.03781 23.5474 3.47943 23.6186 3.96258L25.142 14.6398C25.142 14.65 25.1542 14.7759 25.1542 14.8125V21.7188H26.373C26.5332 21.7185 26.6919 21.7498 26.84 21.8109C26.9881 21.8721 27.1227 21.9618 27.2361 22.075C27.3495 22.1882 27.4394 22.3226 27.5008 22.4706C27.5622 22.6186 27.5938 22.7773 27.5938 22.9375ZM18.903 13.1702L19.4688 13.5938H22.5319L21.2552 4.65625H20.1198L18.903 13.1702ZM7.28125 21.7188H22.7188V16.0312H19.0625C18.7988 16.0312 18.5422 15.9457 18.3313 15.7875L16.8708 14.6927H16.8647L13.7812 12.375V14.8125C13.7812 15.0388 13.7182 15.2607 13.5992 15.4532C13.4802 15.6458 13.31 15.8014 13.1075 15.9026C12.9051 16.0038 12.6785 16.0467 12.453 16.0263C12.2276 16.006 12.0123 15.9233 11.8313 15.7875L7.28125 12.375V21.7188Z"
          fill="#595959"
          className="group-hover:fill-purple-500"
        />
      </g>
      <defs>
        <clipPath id="clip0_6490_121">
          <rect width="29" height="29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Insurance = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      role="presentation"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6443_150)">
        <path
          d="M21.125 11.7812H19.3984V6.09375C19.3984 4.29863 17.9436 2.84375 16.1484 2.84375H9.85156C8.05645 2.84375 6.60156 4.29863 6.60156 6.09375V11.7812H4.875C4.42559 11.7812 4.0625 12.1443 4.0625 12.5938V22.3438C4.0625 22.7932 4.42559 23.1562 4.875 23.1562H21.125C21.5744 23.1562 21.9375 22.7932 21.9375 22.3438V12.5938C21.9375 12.1443 21.5744 11.7812 21.125 11.7812ZM8.42969 6.09375C8.42969 5.30918 9.06699 4.67188 9.85156 4.67188H16.1484C16.933 4.67188 17.5703 5.30918 17.5703 6.09375V11.7812H8.42969V6.09375ZM20.1094 21.3281H5.89062V13.6094H20.1094V21.3281ZM12.2891 17.7988V19.1445C12.2891 19.2563 12.3805 19.3477 12.4922 19.3477H13.5078C13.6195 19.3477 13.7109 19.2563 13.7109 19.1445V17.7988C13.9205 17.6483 14.077 17.4352 14.1577 17.1902C14.2385 16.9452 14.2394 16.6808 14.1604 16.4352C14.0814 16.1896 13.9264 15.9754 13.7179 15.8234C13.5094 15.6715 13.258 15.5896 13 15.5896C12.742 15.5896 12.4906 15.6715 12.2821 15.8234C12.0736 15.9754 11.9186 16.1896 11.8396 16.4352C11.7606 16.6808 11.7615 16.9452 11.8423 17.1902C11.923 17.4352 12.0795 17.6483 12.2891 17.7988Z"
          fill="#595959"
          className="group-hover:fill-purple-500"
        />
      </g>
      <defs>
        <clipPath id="clip0_6443_150">
          <rect width="29" height="29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Logistics = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      role="presentation"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6443_207)">
        <g clip-path="url(#clip1_6443_207)">
          <path
            d="M22.6666 9.66665H19.4166V5.33331H4.24992C3.05825 5.33331 2.08325 6.30831 2.08325 7.49998V19.4166H4.24992C4.24992 21.215 5.70159 22.6666 7.49992 22.6666C9.29825 22.6666 10.7499 21.215 10.7499 19.4166H17.2499C17.2499 21.215 18.7016 22.6666 20.4999 22.6666C22.2983 22.6666 23.7499 21.215 23.7499 19.4166H25.9166V14L22.6666 9.66665ZM22.1249 11.2916L24.2483 14H19.4166V11.2916H22.1249ZM7.49992 20.5C6.90409 20.5 6.41659 20.0125 6.41659 19.4166C6.41659 18.8208 6.90409 18.3333 7.49992 18.3333C8.09575 18.3333 8.58325 18.8208 8.58325 19.4166C8.58325 20.0125 8.09575 20.5 7.49992 20.5ZM9.90492 17.25C9.30909 16.5891 8.46409 16.1666 7.49992 16.1666C6.53575 16.1666 5.69075 16.5891 5.09492 17.25H4.24992V7.49998H17.2499V17.25H9.90492ZM20.4999 20.5C19.9041 20.5 19.4166 20.0125 19.4166 19.4166C19.4166 18.8208 19.9041 18.3333 20.4999 18.3333C21.0958 18.3333 21.5833 18.8208 21.5833 19.4166C21.5833 20.0125 21.0958 20.5 20.4999 20.5Z"
            fill="#595959"
            className="group-hover:fill-purple-500"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6443_207">
          <rect width="29" height="29" fill="white" />
        </clipPath>
        <clipPath id="clip1_6443_207">
          <rect
            width="26"
            height="26"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Sports = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      role="presentation"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6443_221)">
        <path
          d="M15 3.4375C9.16523 3.4375 4.4375 8.16523 4.4375 14C4.4375 19.8246 9.17539 24.5625 15 24.5625C20.8348 24.5625 25.5625 19.8348 25.5625 14C25.5625 8.17539 20.8246 3.4375 15 3.4375ZM21.4645 7.53555C21.8961 7.96719 22.282 8.43437 22.6121 8.93203C22.6477 8.98281 22.6578 9.05391 22.6324 9.10977L21.9012 11.207C21.8809 11.2578 21.8453 11.3035 21.7945 11.3238L18.8746 12.6543C18.8035 12.6848 18.7223 12.6746 18.6613 12.6238L15.7871 10.2066C15.7647 10.187 15.7467 10.1628 15.7345 10.1357C15.7222 10.1085 15.7159 10.079 15.716 10.0492V6.84492C15.716 6.77891 15.7516 6.71289 15.8074 6.67734L17.7574 5.35195C17.8082 5.31641 17.8742 5.30625 17.9352 5.32656C19.2453 5.77852 20.4539 6.525 21.4645 7.53555ZM17.7117 22.648C17.6914 22.709 17.6406 22.7547 17.5797 22.7699C16.752 23.0137 15.8836 23.1355 15 23.1355C14.1113 23.1355 13.248 23.0086 12.4203 22.7699C12.3594 22.7496 12.3086 22.7039 12.2883 22.648L11.4555 20.4645C11.4352 20.4086 11.4402 20.3477 11.4656 20.2969L12.598 18.1488C12.6336 18.0828 12.7047 18.0422 12.7758 18.0422H17.2191C17.2953 18.0422 17.3613 18.0828 17.3969 18.1488L18.5293 20.2969C18.5547 20.3477 18.5598 20.4086 18.5395 20.4645L17.7117 22.648ZM14.2891 6.85508V10.0594C14.2891 10.1203 14.2637 10.1762 14.218 10.2168L11.3387 12.6289C11.2777 12.6797 11.1965 12.6898 11.1254 12.6594L8.20547 11.3289C8.15469 11.3035 8.11406 11.2629 8.09883 11.2121L7.36758 9.11992C7.34727 9.05898 7.35234 8.99297 7.38789 8.94219C7.71797 8.44453 8.10391 7.97734 8.53555 7.5457C9.54609 6.53516 10.7547 5.78867 12.0699 5.34687C12.1309 5.32656 12.1969 5.33672 12.2477 5.37227L14.1977 6.69766C14.2535 6.72305 14.2891 6.78398 14.2891 6.85508ZM5.9457 14.4113L7.77891 12.827C7.83984 12.7762 7.92617 12.7609 7.99727 12.7965L10.6582 14.0051C10.7141 14.0305 10.7547 14.0812 10.7699 14.1422L11.5113 17.052C11.5215 17.1027 11.5164 17.1535 11.4961 17.1992L10.318 19.4285C10.2824 19.4945 10.2113 19.5402 10.1352 19.5352L7.79922 19.5047C7.73828 19.5047 7.67734 19.4742 7.63672 19.4234C6.5957 18.0168 5.98633 16.3461 5.87461 14.5789C5.87461 14.5129 5.9 14.452 5.9457 14.4113ZM19.677 19.4234L18.5039 17.1992C18.4785 17.1535 18.4734 17.1027 18.4887 17.052L19.2301 14.1422C19.2453 14.0812 19.2859 14.0305 19.3418 14.0051L22.0027 12.7965C22.0738 12.766 22.1602 12.7762 22.2211 12.827L24.0543 14.4113C24.1 14.452 24.1305 14.5129 24.1254 14.5789C24.0188 16.3461 23.4043 18.0117 22.3633 19.4234C22.3277 19.4742 22.2668 19.5047 22.2008 19.5047L19.8598 19.5352C19.7836 19.5301 19.7125 19.4895 19.677 19.4234Z"
          fill="#595959"
          className="group-hover:fill-purple-500"
        />
      </g>
      <defs>
        <clipPath id="clip0_6443_221">
          <rect width="29" height="29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Technology = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      role="presentation"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6486_148)">
        <g clip-path="url(#clip1_6486_148)">
          <path
            d="M10.6666 19.3333H19.3333M14.9999 15V19.3333M8.49992 8.50001V7.41668C8.49992 4.16668 10.1249 3.08334 12.8333 3.08334H17.1666C19.8749 3.08334 21.4999 4.70834 21.4999 7.41668V8.50001C24.7499 8.50001 26.9166 10.6667 26.9166 13.9167C26.9166 17.1667 24.7499 19.3333 21.4999 19.3333M8.49992 8.50001H17.1666M8.49992 8.50001C5.24992 8.50001 3.08325 10.125 3.08325 13.9167C3.08325 17.7083 5.24992 19.3333 8.49992 19.3333M10.6666 26.9167H19.3333V15H10.6666V26.9167Z"
            stroke="#595959"
            stroke-width="2"
            className="group-hover:stroke-purple-500"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6486_148">
          <rect width="29" height="29" fill="white" />
        </clipPath>
        <clipPath id="clip1_6486_148">
          <rect
            width="26"
            height="26"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LifeSciences = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      role="presentation"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6490_57)">
        <g clip-path="url(#clip1_6490_57)">
          <path
            d="M9.58341 21.5833C8.39175 21.5833 7.41675 22.5583 7.41675 23.75H22.5834C22.5834 22.5583 21.6084 21.5833 20.4167 21.5833H16.0834V19.4167H19.3334C20.5251 19.4167 21.5001 18.4417 21.5001 17.25H12.8334C11.0351 17.25 9.58341 15.7983 9.58341 14C9.58539 13.4378 9.73316 12.8858 10.0123 12.3978C10.2914 11.9098 10.6923 11.5025 11.1759 11.2158C11.6201 11.855 12.3242 12.2992 13.1584 12.3642C13.9167 12.4292 14.6317 12.1583 15.1626 11.6925L15.8017 13.4367L16.8201 13.0683L17.1884 14.0867L19.2251 13.35L18.8567 12.3317L19.8751 11.9633L16.9067 3.81666L15.8884 4.18499L15.5201 3.16666L13.4834 3.90332L13.8517 4.92166L12.8334 5.30082L13.4401 6.97999C12.1726 6.93666 11.0676 7.79249 10.7534 8.99499C9.76572 9.4073 8.92199 10.1024 8.32829 10.993C7.7346 11.8835 7.41746 12.9297 7.41675 14C7.41675 16.99 9.84342 19.4167 12.8334 19.4167V21.5833H9.58341ZM15.9317 5.89666L17.7842 10.9883L16.7659 11.3567L14.9134 6.26499L15.9317 5.89666ZM13.3751 8.58332C13.9709 8.58332 14.4584 9.07082 14.4584 9.66666C14.4584 10.2625 13.9709 10.75 13.3751 10.75C12.7792 10.75 12.2917 10.2625 12.2917 9.66666C12.2917 9.07082 12.7792 8.58332 13.3751 8.58332Z"
            fill="#595959"
            className="group-hover:fill-purple-500"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6490_57">
          <rect width="29" height="29" fill="white" />
        </clipPath>
        <clipPath id="clip1_6490_57">
          <rect
            width="26"
            height="26"
            fill="white"
            transform="translate(2 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
